import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  popover: {
    '& .MuiPopover-paper': {
      padding: '10px',
      boxShadow: 'none',
      border: '1px solid #A1AAE380',
      borderRadius: '10px;',
      background: '#f1f3fb',
      margin: '-41px -27px',
      [theme.breakpoints.down('sm')]: {
        width: '83%',
        margin: '10px 16px',
      },
      '& .MuiTypography-root': {
        margin: '4px',
        fontSize: '14px',
        '& a': {
          background: '#303d8f',
          padding: 5,
          margin: '7px 0 0',
          display: 'block',
          width: 103,
          borderRadius: 5,
          color: '#fff',
          textAlign: 'center',
          fontSize: 12,
          lineheight: 24,
        },
      },
    },
  },
  BIIcon: {
    padding: 0,
    minWidth: 40,
    height: 40,
    border: '1px solid #fff',
  },
}));
